export const GoogleMapsAPI = `${process.env.REACT_APP_GOOGLE_API_KEY}`;